import {fork, put, takeEvery} from "../../../shared/SagaService";
import actions from "../actions";
import AppActions from "../../App/actions";
import {message} from "antd";
import {readLists} from "../../Transaction/initTransaction/helper/readLists";
import {create} from "./create";
import {read} from "./read";
import {L} from "../../List/reducer";
import {updateStore} from "./helpers/updateStore";
import {updateForm} from "./helpers/updateForm";
import {listenForTransactionCalculations} from "../../Transaction/calculation/saga";

function* initInstruction(action, context) {
    const { matchParams, form } = action;
    const { id, type } = matchParams;

    // Step 1: Read Lists
    yield readLists([L.form_designs, L.settings, L.product_list]);

    // Step 2: If New // Create Instructions
    let instruction,
        transaction;

    if (!id || (id && type))
        [instruction, transaction] = yield create(matchParams, context);

    // Step 2: If View
    else
        [instruction, transaction] = yield read(matchParams, context);

    // Step 3: Update Store / Form
    yield updateStore(instruction, transaction);
    yield updateForm(instruction, transaction, form);
}

export function* initRequest() {
    yield takeEvery(actions.INIT_INSTRUCTION_REQUEST, function* (action, context) {
        try {
            yield put({type: AppActions.APP_START_PULLING});
            yield initInstruction(action, context);
        }
        catch (error) {
            yield put({
                type: actions.INIT_INSTRUCTION_ERROR,
                error,
            });
            yield message.error(error.message);
        }
        finally {
            yield put({type: AppActions.APP_STOP_PULLING});

            // Start calculations
            yield fork(listenForTransactionCalculations, {action});
        }
    });
}
